module.exports = __webpack_public_path__ + "img/f745545.jpg";